import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { useStateMachine } from 'little-state-machine';
import updateAction from '../updateAction';
// import { isEmail } from 'validator';
import { validate_ci } from 'ci_node';

import BackButton from '../components/BackButton';
import Button from '../components/Button';
import Input from '../components/Input';
import StackForm from '../components/StackForm';
import Title from '../components/Title';
import Pill from '../components/Pill';

import useStore from '../store';
import Select from '../components/Select';
import documentos from '../data/documentos';
import { Col, Row } from '../components/Grid';

const display = window.matchMedia('(max-width: 600px)');

const getMaskedNumber = n => {
  // console.log('getMaskedNumber');
  let numero;

  n = n?.replace(/\./g, '').replace(/\-/g, '');

  if (n) {
    numero = parseInt(n, 10);
    numero = numero.toString();
    // console.log({ n, numero });
  } else {
    numero = n;
  }

  const length = numero?.length;

  if (length) {
    const numeros = Array.from(numero);
    let nuevos = numeros;

    if (length > 7) {
      const part3 = numeros.slice(length - 1);
      const part2 = numeros.slice(length - 4, length - 1);
      const part1 = numeros.slice(length - 7, length - 4);
      const part0 = numeros.slice(0, length - 7);
      nuevos = [...part0, '.', ...part1, '.', ...part2, '-', ...part3];
    } else if (length === 7) {
      const part3 = numeros.slice(length - 1);
      const part2 = numeros.slice(length - 4, length - 1);
      const part1 = numeros.slice(length - 7, length - 4);
      nuevos = [...part1, '.', ...part2, '-', ...part3];
    } else if (length === 6) {
      const part2 = numeros.slice(length - 3, length);
      const part1 = numeros.slice(length - 6, length - 3);
      nuevos = [...part1, '.', ...part2];
    }

    return nuevos.join('');
  } else {
    return numero;
  }
};

const Referred = props => {
  const { register, errors, handleSubmit, triggerValidation, watch } = useForm({
    mode: 'onBlur',
  });
  const [store, setStore] = useStore();
  const { action, state } = useStateMachine(updateAction);

  const [numeroCedula, setNumeroCedula] = useState(state?.data?.referrer_document_number || '');
  const [numeroCedulaMasked, setNumeroCedulaMasked] = useState(
    getMaskedNumber(state?.data?.referrer_document_number) || '',
  );

  // const [confirmaCedula, setConfirmaCedula] = useState(false);
  // const [cedulaConfirmada, setCedulaConfirmada] = useState(false);

  const referrer_document_type =
    watch('referrer_document_type') || state?.data?.referrer_document_type || documentos[0].value;

  const [hasReferred, setHasReferred] = useState(state?.data?.hasReferred || null);

  const onSubmit = data => {
    // let cleanValues = {};

    // if (hasReferred === false) {
    //   cleanValues = { referrer_document_type: '', referrer_document_number: '' };
    // }

    action({ hasReferred, ...data /* ...cleanValues */ });
    props.history.push({ pathname: '/9', state: props.location.state });
  };

  const getNumeroCedula = numero => {
    setNumeroCedulaMasked(getMaskedNumber(numero));
    setNumeroCedula(numero);
  };

  const handleReferred = value => {
    setHasReferred(value ? 'yes' : 'no');
  };

  const justAlphanumericWithMax = (event, max) => {
    // hasta 12 caracteres
    if (event.target.value.length >= max) {
      event.preventDefault();
      return false;
    }

    // solo alfanumericos (no espacios, ni guiones, ni ñ)
    // TODO: no deberia aceptar tilde
    const regex = new RegExp('[A-Za-z0-9]+$');
    const key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
    if (!regex.test(key)) {
      event.preventDefault();
      return false;
    }
  };

  // console.log(hasReferred);

  return (
    <StackForm onSubmit={handleSubmit(onSubmit)}>
      <div style={{ minHeight: 360 }}>
        <Title>¿Alguien te recomendó pedir tu tarjeta Itaú?</Title>

        <div style={{ display: 'flex' }}>
          <Pill label="Sí" onClick={() => handleReferred(true)} checked={hasReferred === 'yes'} />
          <Pill label="No" onClick={() => handleReferred(false)} checked={hasReferred === 'no'} />
        </div>

        {hasReferred === 'yes' && (
          <div style={{ marginTop: 40 }}>
            <h3 className="subtitle">Dejanos su documento :)</h3>

            <Row>
              <Col size={display.matches ? 12 : 6}>
                <Select
                  id="referrer_document_type"
                  name="referrer_document_type"
                  label="Tipo de documento"
                  placeholder="Tipo de documento"
                  options={documentos}
                  register={register({
                    required: 'Debe seleccionar un tipo de documento.',
                  })}
                  onChange={e => action({ referrer_document_type: e.target.value })}
                  error={errors.referrer_document_type}
                  defaultValue={state?.data?.referrer_document_type}
                />
              </Col>

              <Col size={display.matches ? 12 : 6}>
                {referrer_document_type == 1 && (
                  <Input
                    type="tel"
                    label="Número de cédula"
                    placeholder="1.234.567-8"
                    id="referrer_document_number"
                    name="referrer_document_number"
                    watch={getNumeroCedula}
                    defaultValue={state?.data?.referrer_document_number}
                    mask={
                      {
                        /* NOTE: Tiene que ser un objeto vacio */
                      }
                    }
                    customMask={numeroCedulaMasked}
                    register={register({
                      required: 'Debe ingresar el número de Cédula de Identidad.',
                      minLength: {
                        value: 7,
                        message: 'Debe tener al menos 7 números.',
                      },
                      maxLength: {
                        value: 8,
                        message: 'Debe tener hasta 8 números.',
                      },
                      validate: {
                        format: value =>
                          validate_ci(value) ? true : 'Cédula de Identidad inválida.',
                        noZeros: value =>
                          value && value[0] != 0 ? true : 'La Cédula no puede empezar con cero.',
                        noEqual: value =>
                          value && value !== state?.data?.numero_cedula
                            ? true
                            : 'El documento debe ser distinto al del solicitante.',
                      },
                    })}
                    error={errors.referrer_document_number}
                    triggerValidation={() => triggerValidation('referrer_document_number')}
                    focusOnMount={true}
                    onKeyPress={event => {
                      if (numeroCedulaMasked.length >= 11) {
                        event.preventDefault();
                        return false;
                      }

                      const regex = new RegExp('[0-9]+$');
                      const key = String.fromCharCode(
                        !event.charCode ? event.which : event.charCode,
                      );
                      if (!regex.test(key)) {
                        event.preventDefault();
                        return false;
                      }
                    }}
                    // onKeyPress={event => {
                    //   if (numeroCedulaMasked.length >= 11) {
                    //     event.preventDefault();
                    //     return false;
                    //   }

                    //   const regex = new RegExp('[0-9]+$');
                    //   const key = String.fromCharCode(
                    //     !event.charCode ? event.which : event.charCode,
                    //   );
                    //   if (!regex.test(key)) {
                    //     event.preventDefault();
                    //     return false;
                    //   }
                    // }}
                  />
                )}

                {referrer_document_type == 2 && (
                  <Input
                    type="tel"
                    label="Número de pasaporte"
                    placeholder="C537001"
                    id="referrer_document_number"
                    name="referrer_document_number"
                    defaultValue={state?.data?.referrer_document_number}
                    register={register({
                      required: 'Debe ingresar el número de Pasaporte.',
                    })}
                    error={errors.referrer_document_number}
                    focusOnMount={true}
                    onKeyPress={e => justAlphanumericWithMax(e, 12)}
                  />
                )}

                {referrer_document_type == 3 && (
                  <Input
                    type="tel"
                    label="Número de DNI"
                    placeholder="123456789"
                    id="referrer_document_number"
                    name="referrer_document_number"
                    defaultValue={state?.data?.referrer_document_number}
                    register={register({
                      required: 'Debe ingresar el número de DNI.',
                      // maxLength: {
                      //   value: 12,
                      //   message: 'Debe tener hasta 12 números.',
                      // },
                    })}
                    error={errors.referrer_document_number}
                    focusOnMount={true}
                    onKeyPress={e => justAlphanumericWithMax(e, 12)}
                  />
                )}

                {referrer_document_type == 4 && (
                  <Input
                    type="tel"
                    label="Número de documento"
                    placeholder="1234567890AB"
                    id="referrer_document_number"
                    name="referrer_document_number"
                    defaultValue={state?.data?.referrer_document_number}
                    register={register({
                      required: 'Debe ingresar el número de documento.',
                    })}
                    error={errors.referrer_document_number}
                    focusOnMount={true}
                    onKeyPress={e => justAlphanumericWithMax(e, 12)}
                  />
                )}
              </Col>
            </Row>
          </div>
        )}
      </div>

      <div className="form-actions">
        <Button
          block
          disabled={hasReferred === null ? true : false}
          type="submit"
          id="next-button-step-8"
        >
          Siguiente
        </Button>

        <BackButton />
      </div>

      <style jsx>{`
        .subtitle {
          margin-top: 0;
          margin-bottom: 32px;
          color: #56504c;
        }
      `}</style>
    </StackForm>
  );
};

export default withRouter(Referred);
